import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createReportCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as ReportCategoriesConstants from "../../../../graphql/Constants/ReportCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";
import * as ModelTypes from "../../../../graphql/Constants/ModelTypes";

const ReportCategoryCreate = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    false
  );

  const handleCreateReportCategory = async () => {
    try {
      const input = {
        type: ModelTypes.ReportCategory,
        name: name.trim(),
        order: order,
        deletedAt: null,
      };
      await API.graphql(graphqlOperation(createReportCategory, { input }));
      return { result: true, message: `ReportCategory created successfully` };
    } catch (error) {
      return { result: false, message: `Error creating ReportCategory, ${error}` };
    }
  };

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Create}
      returnHandler={() => props.history.push(`/reportCategories`)}
      modelName="Report Category"
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === ReportCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleCreateReportCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "ReportCategory",
          false, // we need to exclude the OTHER,
          setCreateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={createButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Report Category Name"
        placeholder="Enter a Report Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "ReportCategory",
            false, // we need to exclude the OTHER,
            setName,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Report Category Order"
        placeholder="Enter a Report Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "ReportCategory",
            setOrder,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default ReportCategoryCreate;
